import React, { Component } from 'react';
import { Modal } from 'antd';
import AssignHkForm from './assignHkForm';
import PropTypes from 'prop-types';

class AssignHk extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  handleCancel = () => {
    this.props.setVisible(false);
  };

  render() {
    const { property, visible, setVisible } = this.props;

    return (
      <>
        <Modal
          title="Assign Housekeeper Preferences"
          visible={visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          <AssignHkForm property={property} setVisible={setVisible} />
        </Modal>
      </>
    );
  }
}

AssignHk.propTypes = {
  property: PropTypes.object,
  visible: PropTypes.bool,
  setVisible: PropTypes.func
};

export default AssignHk;
